import { AnalyticsContextValue } from "@swiggy-private/checkout-core";
import { SCREEN_NAME, CLICK_ACTIONS, IMPRESSION_ACTIONS } from "../constants";
import { CouponTimerPayload } from "@swiggy-private/cart-types";
import { MROAnalyticsPayload } from "@cart-client/interfaces/Coupon";

export const clickApplyCouponBtnEvent = (
    clickEvent: AnalyticsContextValue["clickEvent"],
    couponCode: string,
    groupCartId?: string,
    restaurantId?: string | number,
): void => {
    clickEvent({
        category: SCREEN_NAME.COUPON_LISTING,
        action: CLICK_ACTIONS.CLICK_APPLY_COUPON_TEXT_FIELD,
        label: couponCode,
        // eslint-disable-next-line @typescript-eslint/naming-convention
        extraParams: JSON.stringify({ grp_cart_id: groupCartId, restaurantId }),
    });
};

export const clickMoreDetailsEvent = (
    clickEvent: AnalyticsContextValue["clickEvent"],
    couponCode: string,
    couponType: string,
    groupCartId?: string,
): void => {
    clickEvent({
        category: SCREEN_NAME.COUPON_LISTING,
        action: CLICK_ACTIONS.CLICK_MORE_DETAILS,
        context: couponType,
        label: couponCode,
        // eslint-disable-next-line @typescript-eslint/naming-convention
        extraParams: JSON.stringify({ grp_cart_id: groupCartId }),
    });
};

export const clickCouponOffersEvent = (
    clickEvent: AnalyticsContextValue["clickEvent"],
    labelValue: { couponCode: string; couponType: string },
    contextValue: { storeId: string; offerId: string; isApplicable: string; timerPayload?: CouponTimerPayload },
    groupCartId?: string,
): void => {
    clickEvent({
        category: SCREEN_NAME.COUPON_LISTING,
        action: CLICK_ACTIONS.CLICK_COUPON_OFFERS,
        context: JSON.stringify(contextValue),
        label: JSON.stringify(labelValue),
        // eslint-disable-next-line @typescript-eslint/naming-convention
        extraParams: JSON.stringify({ grp_cart_id: groupCartId }),
    });
};

export const impressionCouponOffersEvent = (
    impressionEvent: AnalyticsContextValue["impressionEvent"],
    payload: {
        offerId: string;
        isApplicable: boolean;
        couponCode: string;
        groupCartId?: string;
        timerPayload?: CouponTimerPayload;
        couponType?: string;
        section?: string;
        description?: string;
    },
): void => {
    impressionEvent({
        category: SCREEN_NAME.COUPON_LISTING,
        action: IMPRESSION_ACTIONS.IMPRESSION_COUPON_OFFERS,
        context: JSON.stringify({
            offerId: payload.offerId,
            isApplicable: payload.isApplicable,
            couponType: payload.couponType,
            section: payload.section,
            description: payload.description,
            ...(payload?.timerPayload || {}),
        }),
        label: payload.couponCode,
        // eslint-disable-next-line @typescript-eslint/naming-convention
        extraParams: JSON.stringify({ grp_cart_id: payload.groupCartId }),
    });
};

export const impressionRewardOffersEvent = (
    impressionEvent: AnalyticsContextValue["impressionEvent"],
    payload: {
        offerId: string;
        isApplicable: boolean;
        couponName?: string;
        couponType?: string;
    },
    groupCartId?: string,
): void => {
    impressionEvent({
        category: SCREEN_NAME.COUPON_LISTING,
        action: IMPRESSION_ACTIONS.IMPRESSION_REWARD_OFFERS,
        context: JSON.stringify({
            offerId: payload.offerId,
            isApplicable: payload.isApplicable,
            couponType: payload.couponType,
        }),
        label: payload.couponName,
        // eslint-disable-next-line @typescript-eslint/naming-convention
        extraParams: JSON.stringify({ grp_cart_id: groupCartId }),
    });
};

export const impressionOffersEvent = (
    impressionEvent: AnalyticsContextValue["impressionEvent"],
    groupCartId?: string,
): void => {
    impressionEvent({
        category: SCREEN_NAME.COUPON_LISTING,
        action: IMPRESSION_ACTIONS.IMPRESSION_OFFERS,
        // eslint-disable-next-line @typescript-eslint/naming-convention
        extraParams: JSON.stringify({ grp_cart_id: groupCartId }),
    });
};

export const impressionPaymentBannerEvent = (
    impressionEvent: AnalyticsContextValue["impressionEvent"],
    bannerText: string,
    groupCartId?: string,
): void => {
    impressionEvent({
        category: SCREEN_NAME.COUPON_LISTING,
        action: IMPRESSION_ACTIONS.IMPRESSION_PAYMENT_BANNER,
        value: bannerText,
        // eslint-disable-next-line @typescript-eslint/naming-convention
        extraParams: JSON.stringify({ grp_cart_id: groupCartId }),
    });
};

export const impressionOfferCroutonEvent = (
    impressionEvent: AnalyticsContextValue["impressionEvent"],
    contextVal: string,
    groupCartId?: string,
    cartId?: number,
): void => {
    impressionEvent({
        category: SCREEN_NAME.COUPON_LISTING,
        action: IMPRESSION_ACTIONS.IMPRESSION_CROUTON_OFFER,
        context: JSON.stringify(contextVal),
        // eslint-disable-next-line @typescript-eslint/naming-convention
        extraParams: JSON.stringify({ grp_cart_id: groupCartId || "-", cart_id: cartId }),
    });
};

export const clickOfferCroutonEvent = (
    clickEvent: AnalyticsContextValue["clickEvent"],
    contextVal: string,
    groupCartId?: string,
    cartId?: number,
): void => {
    clickEvent({
        category: SCREEN_NAME.COUPON_LISTING,
        action: CLICK_ACTIONS.CLICK_CROUTON_OFFER,
        context: JSON.stringify(contextVal),
        // eslint-disable-next-line @typescript-eslint/naming-convention
        extraParams: JSON.stringify({ grp_cart_id: groupCartId || "-", cart_id: cartId }),
    });
};

export const impressionRemoveCoupon = (
    impressionEvent: AnalyticsContextValue["impressionEvent"],
    cartId: string,
): void => {
    impressionEvent({
        category: SCREEN_NAME.COUPON_LISTING,
        action: IMPRESSION_ACTIONS.IMPRESSION_REMOVE_COUPON,
        extraParams: JSON.stringify({ cartId }),
    });
};

export const clickRemoveCoupon = (
    clickEvent: AnalyticsContextValue["clickEvent"],
    cartId: string,
    couponCode: string,
    couponType?: string,
): void => {
    clickEvent({
        category: SCREEN_NAME.COUPON_LISTING,
        action: CLICK_ACTIONS.CLICK_REMOVE_COUPON,
        label: JSON.stringify({ couponCode, couponType }),
        extraParams: JSON.stringify({ cartId }),
    });
};

//impression-half-card-invalid-coupon
export const impressionHalfCardInvalidCoupon = (
    impressionEvent: AnalyticsContextValue["impressionEvent"],
    text: string,
    cartId: string,
): void => {
    impressionEvent({
        category: SCREEN_NAME.COUPON_LISTING,
        action: IMPRESSION_ACTIONS.IMPRESSION_HALF_CARD_INVALID_COUPON,
        context: JSON.stringify({ text, cartId }),
    });
};

export const clickHalfCardInvalidCoupon = (
    clickEvent: AnalyticsContextValue["clickEvent"],
    text: string,
    cartId: string,
): void => {
    clickEvent({
        category: SCREEN_NAME.COUPON_LISTING,
        action: CLICK_ACTIONS.CLICK_HALF_CARD_INVALID_COUPON,
        context: JSON.stringify({ text, cartId }),
    });
};

export const impressionMROCouponClashPopup = ({
    impressionEvent,
    payload,
}: {
    impressionEvent: AnalyticsContextValue["impressionEvent"];
    payload: MROAnalyticsPayload;
}): void => {
    impressionEvent({
        category: SCREEN_NAME.COUPON_LISTING,
        action: IMPRESSION_ACTIONS.IMPRESSION_COUPON_CLASH_POPUP,
        context: JSON.stringify({ ...payload }),
    });
};

export const clickMROCouponClashPopup = ({
    clickEvent,
    payload,
    text,
}: {
    clickEvent: AnalyticsContextValue["clickEvent"];
    payload: MROAnalyticsPayload;
    text: string;
}): void => {
    clickEvent({
        category: SCREEN_NAME.COUPON_LISTING,
        action: CLICK_ACTIONS.CLICK_COUPON_CLASH_POPUP,
        context: JSON.stringify({ ...payload, text }),
    });
};
